var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52916 12.6845C8.34144 12.146 9.24472 11.734 10.2095 11.477L11.5749 8.0405L8.62944 0.625732H10.5931L12.5567 5.56892L14.5203 0.625732H16.484L12.2936 11.1751C12.3806 11.1725 12.4684 11.1712 12.5567 11.1712C14.413 11.1712 16.141 11.7281 17.5843 12.6845L22.3749 0.625732H24.3386L19.0635 13.9045C20.7058 15.572 21.7203 17.8668 21.7203 20.3984C21.7203 25.4913 17.6144 29.6257 12.5567 29.6257C7.49904 29.6257 3.39309 25.4913 3.39309 20.3984C3.39309 17.8668 4.40763 15.572 6.04989 13.9045L0.774902 0.625732H2.73853L7.52916 12.6845ZM12.4055 13.1484C8.43178 13.1484 5.20552 16.3971 5.20552 20.3984C5.20552 24.3998 8.43178 27.6484 12.4055 27.6484C16.3792 27.6484 19.6055 24.3998 19.6055 20.3984C19.6055 16.3971 16.3792 13.1484 12.4055 13.1484Z",
    fill: "url(#paint0_linear_202_1307)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_1307",
    x1: 12.5567,
    y1: 0.625732,
    x2: 12.5567,
    y2: 29.6257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21438A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4052A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_1307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 29,
    fill: "white",
    transform: "translate(0.774902 0.625732)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.b9332d54c088c73a98d1917d58baddf1.svg";
export { ForwardRef as ReactComponent };